import FooterImage from './footerImage'

export default FooterImage